import $ from 'jquery';


$(document).ready(function(){
  $(".hamburger, .toggle-menu-title").click(function(){
    $('body').toggleClass('menu-open');
  });
  $('.menu-wrapper').on('click', function() {
     $('body').removeClass('menu-open');
  });
  $('.menu-inner-wrapper').on('click', function(e) {
      e.stopPropagation();
  });

  $(".language-active a").click(function(e){
      e.preventDefault();
      $('.language-switcher').toggleClass('active');
  });
});


// WEBPACK FOOTER //
// ./assets/js/src/modules/menu.js